// import {useSelector} from "react-redux";
import { Navigate, Outlet } from 'react-router-dom';
const PrivateManagerRoute = () => {
  // const {userToken } = useSelector( state => state.authReducer );

  const userToken = localStorage.getItem('managerToken');
  return userToken ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateManagerRoute;
